var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.5L10.1 9C10 8.86667 9.86667 8.8 9.7 8.8C9.53333 8.8 9.4 8.86667 9.3 9L7.625 11.2C7.49167 11.3667 7.47083 11.5417 7.5625 11.725C7.65417 11.9083 7.80833 12 8.025 12H15.975C16.1917 12 16.3458 11.9083 16.4375 11.725C16.5292 11.5417 16.5083 11.3667 16.375 11.2L13.95 8.025C13.85 7.89167 13.7167 7.825 13.55 7.825C13.3833 7.825 13.25 7.89167 13.15 8.025L11.25 10.5ZM6 16C5.45 16 4.97917 15.8042 4.5875 15.4125C4.19583 15.0208 4 14.55 4 14V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H6ZM6 14H18V2H6V14ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V5C0 4.71667 0.0958333 4.47917 0.2875 4.2875C0.479167 4.09583 0.716667 4 1 4C1.28333 4 1.52083 4.09583 1.7125 4.2875C1.90417 4.47917 2 4.71667 2 5V18H15C15.2833 18 15.5208 18.0958 15.7125 18.2875C15.9042 18.4792 16 18.7167 16 19C16 19.2833 15.9042 19.5208 15.7125 19.7125C15.5208 19.9042 15.2833 20 15 20H2Z",
    fill: "#003460"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoLibrary);
export default __webpack_public_path__ + "static/media/photo_library.e5219ef4bf08aefbe9716366430bfe3c.svg";
export { ForwardRef as ReactComponent };